module.exports = __webpack_public_path__ + "static/img/中工云课堂.6b687d33.png";